{
  "account_number": "34",
  "chain_id": "Binance-Chain-Nile",
  "data": "null",
  "memo": "test",
  "msgs": [
    {
      "inputs": [
        {
          "address": "bnb1afwh46v6nn30nkmugw5swdmsyjmlxslgjfugre",
          "coins": [{ "amount": 1000000000, "denom": "BNB" }]
        }
      ],
      "outputs": [
        {
          "address": "bnb1ss57e8sa7xnwq030k2ctr775uac9gjzg347gp4",
          "coins": [{ "amount": 1000000000, "denom": "BNB" }]
        }
      ]
    }
  ],
  "sequence": "31",
  "source": "1"
}
